<template>
    <AdminLayout :crumbs="crumbs" :season_id="season_id">
        <template v-if="season">
            <EventHeader :season="season" />

            <div class="a-card">
                <div class="a-card-header">
                    <div class="seg">
                        <button type="button" :class="{ active: filter == 'online' }" @click="filter = 'online'">Conectados <span class="a-count">{{ online_count }}</span></button>
                        <button type="button" :class="{ active: filter == 'all' }" @click="filter = 'all'">Todos <span class="a-count">{{ enrolled.length }}</span></button>
                    </div>
                    <div class="a-search" style="max-width: 280px; flex: 1">
                        <i class="bi bi-search"></i>
                        <input type="search" class="form-control" v-model="search" placeholder="Buscar equipo">
                    </div>
                </div>

                <div v-if="guests.length && filter == 'online'" class="guests">
                    <i class="bi bi-hourglass-split me-1"></i>{{ guests.length }} {{ guests.length == 1 ? 'persona está' : 'personas están' }} eligiendo equipo ahora mismo.
                </div>

                <ul class="a-list" v-if="rows.length">
                    <li v-for="p in rows" :key="p.id" class="a-row a-row-link" @click="$refs.user.open(p.uuid)">
                        <span class="jersey" :style="{ backgroundColor: (p.avatar_style && p.avatar_style.color) || 'var(--a-line-strong)' }"></span>
                        <div class="a-row-main">
                            <div class="a-row-title">{{ p.username }}</div>
                            <div class="a-row-meta">
                                <span v-if="p.online">{{ view_label(p.current_view) }}</span>
                                <span v-else>Desconectado</span>
                                <span>{{ plural((p.data || []).length, 'respuesta') }}</span>
                            </div>
                        </div>
                        <span class="score">{{ score(p) }} <small>pts</small></span>
                        <span class="a-pill" :class="p.online ? 'a-pill-ok' : 'a-pill-muted'">{{ p.online ? 'Conectado' : 'Fuera' }}</span>
                        <i class="bi bi-chevron-right a-muted"></i>
                    </li>
                </ul>
                <div v-else class="a-empty">
                    <i class="bi bi-people"></i>
                    <div class="a-empty-title">{{ empty_title }}</div>
                    <div v-if="!search && !enrolled.length">Los equipos aparecen aquí al registrarse con el código de acceso del {{ season_label.toLowerCase() }}.</div>
                </div>
            </div>
        </template>
        <UserDetailModal ref="user" />
    </AdminLayout>
</template>

<script>
import utils from '@/../../shared/utils'
import AdminLayout from '@/components/admin/AdminLayout.vue'
import EventHeader from '@/components/admin/EventHeader.vue'
import UserDetailModal from '@/components/admin/UserDetailModal.vue'
import { view_label, plural } from '@/utils/admin-format'

// The teams signed up to one event (season_users), live or not.
export default {
    name: 'EventParticipants',
    components: { AdminLayout, EventHeader, UserDetailModal },
    data(){
        return { filter: 'online', search: '' };
    },
    created(){
        // Nobody connected right now: the full roster is the useful view.
        if(!this.online_count) this.filter = 'all';
    },
    computed: {
        game(){ return this.$store.state.game; },
        season_id(){ return parseInt(this.$route.params.season_id, 10); },
        season(){ return (this.game.seasons || []).find((s) => s.id == this.season_id) || null; },
        season_label(){ return utils.get_season_label(window.MODE); },
        crumbs(){
            return [
                { label: utils.get_season_label(window.MODE, true), to: { name: 'Panel' } },
                { label: this.season ? this.season.name : '…', to: { name: 'Stages', params: { season_id: this.season_id } } },
                { label: 'Participantes' },
            ];
        },
        // Registered roster merged with live connections (live data wins).
        enrolled(){
            const ids = new Set((this.game.season_users || []).filter((su) => su.season_id == this.season_id).map((su) => su.user_id));
            const clients = this.game.clients || [];
            const merged = new Map();
            (this.game.users || []).forEach((u) => { if(ids.has(u.id)) merged.set(u.id, Object.assign({}, u, { online: false })); });
            clients.forEach((c) => { if(ids.has(c.id)) merged.set(c.id, Object.assign({}, merged.get(c.id) || {}, c, { online: true })); });
            return Array.from(merged.values()).sort((a, b) => (b.online - a.online) || (a.username || '').localeCompare(b.username || ''));
        },
        online_count(){ return this.enrolled.filter((p) => p.online).length; },
        guests(){ return (this.game.clients || []).filter((c) => c.role == utils.USER_ROLES.GUEST); },
        rows(){
            const term = this.search.trim().toLowerCase();
            return this.enrolled.filter((p) => (this.filter == 'all' || p.online) && (p.username || '').toLowerCase().includes(term));
        },
        empty_title(){
            if(this.search) return 'Ningún equipo coincide';
            if(this.filter == 'online' && this.enrolled.length) return 'Ningún equipo conectado ahora mismo';
            return 'Todavía no hay equipos inscritos';
        }
    },
    methods: {
        view_label,
        plural,
        score(p){
            const s = utils.calc_score(p.data || []);
            return s ? Math.round(s) : 0;
        }
    }
}
</script>

<style lang="scss" scoped>
.seg{
    display: inline-flex;
    background: var(--a-surface-2);
    border: 1px solid var(--a-line);
    border-radius: 8px;
    padding: 2px;
    button{
        border: 0;
        background: none;
        padding: 5px 12px;
        border-radius: 6px;
        font-weight: 600;
        font-size: 0.85rem;
        color: var(--a-text-2);
        display: inline-flex;
        gap: 6px;
        align-items: center;
        &.active{ background: var(--a-surface); color: var(--a-text); box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08); }
    }
    .a-count{
        font-size: 0.72rem;
        background: var(--a-line);
        border-radius: 999px;
        padding: 0 6px;
    }
}
.guests{
    padding: 10px 18px;
    background: var(--a-warn-soft);
    color: var(--a-warn);
    font-size: 0.85rem;
    border-bottom: 1px solid var(--a-line);
}
.jersey{
    width: 14px;
    height: 32px;
    border-radius: 4px;
    flex-shrink: 0;
}
.score{
    font-family: "Archivo", sans-serif;
    font-weight: 800;
    min-width: 64px;
    text-align: right;
    small{ font-family: "Public Sans", sans-serif; font-weight: 600; color: var(--a-text-3); font-size: 0.72rem; }
}
</style>
